<template>
  <div></div>
</template>

<script>
export default {
  name: "GameReferee",

  props: {
    matchId: {
      type: String,
      default: null,
    },
  },

  data() {
    return {
      isReadyEmitted: false,
    };
  },

  watch: {
    matchId: {
      async handler() {
        if (!this.matchId) return;

        await this.referee.init(this.matchId);
      },
      immediate: true,
    },

    match() {
      if (!this.match) {
        return;
      }

      if (this.isReadyEmitted) {
        return;
      }

      if (this.match.createdAt) {
        this.isReadyEmitted = true;
        this.$emit("onGameReady");
      }
    },
  },
};
</script>
